import React from 'react'
import { IconButtons } from '../ui-components'
import Card from "../components/Card";
import { Button } from "@aws-amplify/ui-react";
import FormDetailLeadManager from './FormDetailLead';


function DetailLead({onToggleTab, assingLead}) {

  return (
    <div className="mt-16">
      <Card
      textTitle="Detalles del Lead"
      classNameBody="py-8"
      elementBody={
        <div className="flex flex-col gap-1 px-6">
          <div className="flex justify-end"> 
            <Button variation="primary" size="small" onClick={() =>onToggleTab(1)}><IconButtons variant="back"/> Atrás</Button>
          </div>
            <FormDetailLeadManager id={assingLead} onToggleTab={onToggleTab}/>
        </div>
      }
    />
    </div>
  )
}

export default DetailLead